import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AccountNumberService } from '@deltager/organizers/admin/core/services/account-number.service';
import { BaseComponent } from '@deltager/organizers/admin/shared/components/base.component';
import { BufferTransaction } from '@deltager/organizers/admin/shared/models/buffer-transaction';
import { takeUntil } from 'rxjs/operators';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { PipesModule } from '@deltager/organizers/admin/shared/pipes/pipes.module';

@Component({
  selector: 'app-buffer-history-table',
  templateUrl: './buffer-history-table.component.html',
  styleUrls: ['./buffer-history-table.component.scss'],
  standalone: true,
  imports: [
    MatProgressBarModule,
    MatExpansionModule,
    TranslateModule,
    MatTableModule,
    MatPaginatorModule,
    DatePipe,
    PipesModule,
  ],
})
export class BufferHistoryTableComponent extends BaseComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input({ required: true }) id: number;
  @Input({ required: true }) clubId: number;
  @Input({ required: true }) currencyCode: string;

  public readonly DISPLAYED_COLUMNS = [
    'date',
    'type',
    'amount',
    'previousBalance',
    'newBalance',
    'reference',
    'action',
  ];

  public isLoading = false;
  public bufferHistoryDataSource = new MatTableDataSource<BufferTransaction>();
  public pageSize = 5;
  public pageNumber = 1;
  public pageSizeOptions = [5, 10, 20, 50];
  public bufferTransactionHistory: BufferTransaction[];

  constructor(private accountNumberService: AccountNumberService) {
    super();
  }

  ngOnInit(): void {
    this.getBufferTransactionHistory();
  }

  public getPaginatorData(event: PageEvent) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;

    return event;
  }

  private getBufferTransactionHistory(): void {
    this.isLoading = true;

    this.accountNumberService
      .getBufferTransactionHistory(this.id, this.clubId, this.pageSize, this.pageNumber)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: response => {
          this.bufferTransactionHistory = response;
          this.prepareForPagination(response);
          this.isLoading = false;
        },
        error: error => {
          this.isLoading = false;
        },
      });
  }

  private prepareForPagination(data: any) {
    setTimeout(() => {
      this.bufferHistoryDataSource = new MatTableDataSource<any>(data);

      if (this.paginator) {
        this.paginator.pageIndex = this.pageNumber - 1;
        this.paginator.pageSize = this.pageSize;
        this.paginator.length = 0;
      }

      this.bufferHistoryDataSource.paginator = this.paginator;
    });
  }
}
